// extracted by mini-css-extract-plugin
module.exports = {"moreButton":"_2_gzB","openButton":"_wACm","arrow":"_3GiYf","arrowUp":"_1gDEo","actionText":"_1xipp","preLabel":"Gn1mP"};